import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AdministrationRequestModel, IAdministrationResponseModel } from "@tsin-core/states/administration/administration.model";
import { environment } from "@tsin-env/environment";
import { catchError, Observable, throwError } from "rxjs";

const BASE_URL = `${environment.apiUrl}`;

const ASSIGNMENT_URL = `${environment.apiUrl2}/administration`;
const ASSIGNMENT_NEW_URL = `${environment.apiUrl2}`;

@Injectable({
  providedIn: 'root'
})

export class AdministrationService {

  http: HttpClient = inject(HttpClient);

  getAdministrations(): Observable<IAdministrationResponseModel[]> {
    return this.http.get<IAdministrationResponseModel[]>(`${BASE_URL}/administration`).pipe(
      catchError(error => {
        console.error('Error fetching administrations:', error);
        return throwError(() => error);
      })
    );
  }

  getAdministration(id: string): Observable<AdministrationRequestModel> {
    return this.http.get<AdministrationRequestModel>(`${BASE_URL}/administration/single/${id}`).pipe(
      catchError(error => {
        console.error('Error fetching administration:', error);
        return throwError(() => error);
      })
    );
  }

  getSingleAdministration(id: string): Observable<AdministrationRequestModel> {
    return this.http.get<AdministrationRequestModel>(`${BASE_URL}/administration/interviewers-and-moderators/${id}`).pipe(
      catchError(error => {
        console.error('Error fetching administration:', error);
        return throwError(() => error);
      })
    );
  }

  createAdministration(formData: Omit<AdministrationRequestModel, 'id'>): Observable<IAdministrationResponseModel> {
    return this.http.post<IAdministrationResponseModel>(`${BASE_URL}/administration`, formData).pipe(
      catchError(error => {
        console.error('Error fetching administration:', error);
        return throwError(() => error);
      })
    );
  }

  updateAdministration(formData: AdministrationRequestModel): Observable<IAdministrationResponseModel> {
    return this.http.put<IAdministrationResponseModel>(`${BASE_URL}/administration`, formData).pipe(
      catchError(error => {
        console.error('Error fetching administration:', error);
        return throwError(() => error);
      })
    );
  }

  deleteAdministration(id: string): Observable<AdministrationRequestModel> {
    return this.http.delete<AdministrationRequestModel>(`${BASE_URL}/administration/single/${id}`).pipe(
      catchError(error => {
        console.error('Error fetching administration:', error);
        return throwError(() => error);
      })
    );
  }

  // POST: Create a new interviewer
  assignModerators(moderators: any): Observable<any> {
    return this.http.post(`${ASSIGNMENT_URL}/assign-moderators`, moderators);
  }

  // POST: Create a new interviewer
  assignInterviewers(interviewees: any): Observable<any> {
    return this.http.post(`${ASSIGNMENT_URL}/assign-interviewers`, interviewees);
  }


  // POST: Create a new interviewer
  assignInterviewees(interviewers: any): Observable<any> {
    return this.http.post(`${ASSIGNMENT_URL}/assign-interviewees`, interviewers);
  }
}
